import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function TermsOfService() {
  const navigate = useNavigate();
  
  return (
    <div className="container mx-auto px-4 py-8 max-w-3xl">
      <button 
        onClick={() => navigate('/')} 
        className="flex items-center text-gray-600 mb-6 hover:text-gray-900"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
        </svg>
        Back
      </button>
      
      <h1 className="text-3xl font-bold mb-6">Terms of Service</h1>
      <p className="text-sm text-gray-600 mb-6">Effective Date: April 11, 2025</p>
      
      <div className="prose max-w-none">
        <p>
          Welcome to Aptmetrix! By accessing or using our website (https://aptmetrix.kr), you agree to comply with and be bound by these Terms and Conditions. Please read them carefully.
        </p>
        
        <p>
          These Terms and Conditions are designed to comply with applicable laws, including the General Data Protection Regulation (GDPR) and South Korea's Personal Information Protection Act (PIPA).
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">1. Introduction</h2>
        <p>
          Aptmetrix is a real estate data analytics platform that enables users to access and analyze apartment market data in South Korea. Aptmetrix is owned and operated by Insight&Myung, LLC ("we", "our", or "us").
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">2. User Data Collection and Use</h2>
        <p>
          We collect and process personal data as necessary to provide our services. This includes:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Name</li>
          <li>Email</li>
          <li>Payment information</li>
        </ul>
        <p>
          We use this data to:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Provide our services</li>
          <li>Process payments</li>
          <li>Improve our services</li>
          <li>Communicate with you about our services</li>
          <li>Comply with legal obligations</li>
        </ul>
        <p>
          For full details on our data practices, please review our <a href="/privacy" className="text-blue-600 hover:underline">Privacy Policy</a>.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">3. User Rights</h2>
        <p>
          Users have certain rights regarding their personal data, including the right to access, correct, delete, and port their data. These rights may vary depending on your location. To exercise your rights, please contact us at jinhom6225@insightmyung.com.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">4. User Responsibilities</h2>
        <p>
          By using Aptmetrix, you agree to:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Provide accurate and complete information</li>
          <li>Use our services in compliance with these Terms and Conditions and applicable laws</li>
          <li>Not use our services for any illegal or unauthorized purpose</li>
          <li>Not infringe on the intellectual property rights of others</li>
        </ul>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">5. Intellectual Property</h2>
        <p>
          All content and materials available on Aptmetrix, unless otherwise specified, are the property of Insight&Myung, LLC and are protected by applicable intellectual property laws.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">6. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted by applicable law, Insight&Myung, LLC shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">7. Governing Law and Jurisdiction</h2>
        <p>
          These Terms and Conditions are governed by the laws of South Korea. Any disputes arising from these Terms and Conditions shall be subject to the exclusive jurisdiction of the courts in South Korea.
        </p>
        <p>
          For users in the European Union, you also have the right to bring legal proceedings in your country of residence.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">8. Changes to the Terms</h2>
        <p>
          We may update these Terms and Conditions from time to time. Users will be notified of any material changes via email and through our website. Your continued use of Aptmetrix after such changes constitutes your acceptance of the new Terms and Conditions.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">9. Termination</h2>
        <p>
          We reserve the right to terminate or suspend your account and access to Aptmetrix at our sole discretion, without notice, for conduct that we believe violates these Terms and Conditions or is harmful to other users of Aptmetrix, us, or third parties, or for any other reason.
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">10. Contact Information</h2>
        <p>
          If you have any questions or concerns about these Terms and Conditions, please contact us at:
        </p>
        <p>
          Insight&Myung, LLC<br />
          Email: jinhom6225@insightmyung.com
        </p>
        
        <h2 className="text-xl font-semibold mt-6 mb-3">11. Payment and Refund Policy</h2>
        <p>
          All subscription fees are non-refundable, except that you may request and receive a full refund if requested within seven (7) days of the subscription start date or renewal date. After the seven-day period, all subscription charges are final and non-refundable.
        </p>
        
        <p className="mt-6">
          Thank you for using Aptmetrix!
        </p>
      </div>
    </div>
  );
}
